import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=074d6a21&scoped=true&"
import script from "./InputField.vue?vue&type=script&lang=ts&"
export * from "./InputField.vue?vue&type=script&lang=ts&"
import style0 from "./input_field.scss?vue&type=style&index=0&id=074d6a21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d6a21",
  null
  
)

export default component.exports